import * as z from "zod/v4";

export const upsertGrowaveIntegration = {
  name: "upsertGrowaveIntegration" as const,
  input: z.object({ clientId: z.string(), clientSecret: z.string() }),
  output: z.object({ success: z.boolean() }),
};
